import { ProjectsOverview } from './Pages/ProjectsOverview/ProjectsOverview';
import { TimeOverview } from './Pages/TimeOverview/TimeOverview';

export const mobileRouting = [
    { path: '/', component: TimeOverview },
    { path: '/projects', component: ProjectsOverview },
];
